/* ================================================= support page behaviours
   <keis-support-search>  suggestions under the support search box, from the
                          FAQ page's own questions (sections/support-hero).
                          Enter with none chosen searches the FAQ page for
                          what was typed; the form does that without script.
   <keis-open-status>     whether the team is in right now, in the shop's
                          time zone, and if not, when they are back. Follows
                          the Christmas (holiday) days set in the KEIS app.
   ========================================================================= */
(function () {
  'use strict';

  var norm = function (s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  };

  if (!customElements.get('keis-support-search')) {
    class SupportSearch extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.input = this.querySelector('input[type="search"]');
        this.list = this.querySelector('[role="listbox"]');
        this.faq = (this.querySelector('[data-support-faq-url]') || {}).getAttribute
          ? this.querySelector('[data-support-faq-url]').getAttribute('data-support-faq-url') : '/pages/faq';
        var raw = this.querySelector('[data-support-questions]');
        try { this.questions = JSON.parse(raw ? raw.textContent : '[]').filter(Boolean); } catch (e) { this.questions = []; }
        this.questions.forEach(function (q) { q.n = norm(q.q + ' ' + q.t); });
        /* Ranked by the same search as the FAQ page (keis-faqsearch.js), so
           a suggestion here is the answer the FAQ page would put first. */
        this.index = window.KeisFaqSearch
          ? window.KeisFaqSearch.index(this.questions.map(function (q) { return { q: q.q, a: '', ctx: q.t }; }))
          : null;
        this.active = -1;
        if (!this.input || !this.list || !this.questions.length) return;

        this.input.addEventListener('input', function () { self.suggest(); });
        this.input.addEventListener('keydown', function (e) { self.key(e); });
        this.input.addEventListener('blur', function () { setTimeout(function () { self.close(); }, 150); });
        this.input.addEventListener('focus', function () { if (self.input.value.trim()) self.suggest(); });
        /* Insights: a suggestion followed. A plain search is counted on the
           FAQ page it lands on. */
        this.list.addEventListener('mousedown', function (e) {
          var a = e.target.closest && e.target.closest('a');
          if (a) self.trackSuggestion(a);
        });
      }

      suggest() {
        var typed = this.input.value.trim();
        var words = norm(typed).split(/\s+/).filter(Boolean);
        if (!words.length) { this.close(); return; }
        var qs = this.questions;
        var hits = this.index
          ? window.KeisFaqSearch.search(this.index, typed).slice(0, 6).map(function (r) { return qs[r.i]; })
          : qs.filter(function (q) { return words.every(function (w) { return q.n.indexOf(w) !== -1; }); }).slice(0, 6);
        this.active = -1;
        if (!hits.length) { this.close(); return; }
        var faq = this.faq;
        this.list.innerHTML = hits.map(function (q, i) {
          var href = faq + '?q=' + encodeURIComponent(q.q);
          return '<li role="option" id="' + this.list.id + '-' + i + '" aria-selected="false">' +
            '<a href="' + href + '"><span class="keis-supporthero__sq"></span><span class="keis-supporthero__st"></span></a></li>';
        }, this).join('');
        Array.prototype.forEach.call(this.list.querySelectorAll('li'), function (li, i) {
          li.querySelector('.keis-supporthero__sq').textContent = hits[i].q;
          li.querySelector('.keis-supporthero__st').textContent = hits[i].t;
        });
        this.list.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      }

      key(e) {
        var items = this.list.hidden ? [] : this.list.querySelectorAll('li');
        if (e.key === 'Escape') { this.close(); return; }
        if (!items.length || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter')) return;
        if (e.key === 'Enter') {
          if (this.active >= 0) {
            e.preventDefault();
            this.trackSuggestion(items[this.active].querySelector('a'));
            window.location.href = items[this.active].querySelector('a').href;
          }
          return;
        }
        e.preventDefault();
        this.active = (this.active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        Array.prototype.forEach.call(items, function (li, i) { li.setAttribute('aria-selected', i === this.active ? 'true' : 'false'); }, this);
        this.input.setAttribute('aria-activedescendant', items[this.active].id);
      }

      trackSuggestion(a) {
        var q = a && a.querySelector('.keis-supporthero__sq');
        if (q && window.keisTrack) window.keisTrack('support', 'suggestion', q.textContent.trim());
      }

      close() {
        this.list.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
      }
    }
    customElements.define('keis-support-search', SupportSearch);
  }

  if (!customElements.get('keis-open-status')) {
    var mins = function (hhmm) {
      var m = String(hhmm || '').match(/^(\d{1,2}):?(\d{2})?$/);
      return m ? Number(m[1]) * 60 + Number(m[2] || 0) : null;
    };

    /* Now in the shop's time zone: its date and the minute of the day.
       ?keis_date=2026-12-24 (or 2026-12-24T14:30) pretends it is that day,
       to check the Christmas hours ahead of time. */
    var shopNow = function (tz) {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date());
      var get = function (t) { return Number((parts.find(function (p) { return p.type === t; }) || {}).value); };
      var now = { y: get('year'), m: get('month'), d: get('day'), min: get('hour') * 60 + get('minute') };
      var q = /[?&]keis_date=(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}))?/.exec(location.search);
      if (q) {
        now.y = Number(q[1]); now.m = Number(q[2]); now.d = Number(q[3]);
        if (q[4]) now.min = Number(q[4]) * 60 + Number(q[5]);
      }
      return now;
    };

    /* A day more than a week away is named with its date ("Monday 4 January"),
       in the page's language. */
    var longDay = function (date) {
      var lang = document.documentElement.lang || 'en';
      if (/^en$/i.test(lang)) lang = 'en-GB';
      try { return new Intl.DateTimeFormat(lang, { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }).format(date); }
      catch (e) { return date.toISOString().slice(0, 10); }
    };

    class OpenStatus extends HTMLElement {
      connectedCallback() {
        this.render();
        var self = this;
        this.timer = setInterval(function () { self.render(); }, 60000);
      }
      disconnectedCallback() { clearInterval(this.timer); }

      render() {
        var text = this.querySelector('[data-status-text]');
        var from = mins(this.dataset.from), to = mins(this.dataset.to);
        if (!text || from === null || to === null) return;
        var range = String(this.dataset.days || '1-5').split('-').map(Number);
        var usual = { from: from, to: to, fromText: this.dataset.from, toText: this.dataset.to };

        /* Days that differ from the usual week (Christmas and the like), from
           the KEIS app (Holidays): { s: first day, e: last day, c: closed,
           f / t: opening and closing time }. They win over the usual week. */
        var special;
        try { special = JSON.parse(this.dataset.special || 'null') || []; } catch (e) { special = []; }
        var hoursOn = function (iso, weekday) {
          for (var i = 0; i < special.length; i += 1) {
            var x = special[i];
            if (iso >= x.s && iso <= x.e) {
              var f = mins(x.f), t = mins(x.t);
              return x.c || f === null || t === null ? null : { from: f, to: t, fromText: x.f, toText: x.t };
            }
          }
          return weekday >= range[0] && weekday <= range[1] ? usual : null;
        };

        var now;
        try { now = shopNow(this.dataset.tz || 'Europe/London'); } catch (e) { return; }
        var base = Date.UTC(now.y, now.m - 1, now.d);
        var dayAt = function (n) {
          var t = new Date(base + n * 864e5);
          return { date: t, iso: t.toISOString().slice(0, 10), weekday: t.getUTCDay() };
        };

        var today = dayAt(0);
        var hours = hoursOn(today.iso, today.weekday);
        var open = !!hours && now.min >= hours.from && now.min < hours.to;
        this.classList.toggle('is-open', open);
        this.classList.toggle('is-closed', !open);
        if (open) {
          text.textContent = (this.dataset.open || '').replace('[until]', hours.toText);
          return;
        }
        var names = String(this.dataset.daysNames || 'Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday').split(',');
        /* A month ahead: far enough to see past a Christmas closure. */
        for (var n = 0; n < 32; n += 1) {
          var day = dayAt(n);
          var h = hoursOn(day.iso, day.weekday);
          if (!h || (n === 0 && now.min >= h.from)) continue;
          var when = n === 0 ? (this.dataset.today || 'today')
            : n === 1 ? (this.dataset.tomorrow || 'tomorrow')
            : n < 7 ? names[day.weekday].trim()
            : longDay(day.date);
          var at = (this.dataset.dayAt || '[day] at [time]').replace('[day]', when).replace('[time]', h.fromText);
          text.textContent = (this.dataset.closed || '').replace('[next]', at);
          return;
        }
      }
    }
    customElements.define('keis-open-status', OpenStatus);
  }

  /* Insights: a popular-search shortcut under the support search. */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-track-popular]');
    if (chip && window.keisTrack) window.keisTrack('support', 'popular', chip.getAttribute('data-track-popular'));
  });
})();
